var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 163,
    viewBox: "0 0 103 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2365 96.4746C64.2751 90.8033 59.3045 83.7453 55.846 75.7617C52.3876 67.778 50.4773 58.8889 50.4408 49.7294C50.4294 46.2336 50.6806 42.6963 51.202 39.1455L71.9428 55.9223L57.4204 7.31472L15.7487 36.9135L42.1554 36.217C40.5296 40.0694 39.1839 44.0565 38.1545 48.1984C35.5614 58.6492 35.0614 69.8555 36.8156 80.9589C38.5622 92.0342 42.6196 102.991 48.807 112.944C54.9943 122.897 63.3888 131.795 73.3334 138.792L90.4137 109.182C83.1423 106.403 76.2262 102.138 70.2365 96.4746Z",
    fill: "#F5AB32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.349 42.0025C52.0675 44.5921 51.9325 47.1695 51.9407 49.7234L52.349 42.0025ZM52.349 42.0025L70.9994 57.0886L74.7673 60.1363L73.38 55.4929L58.8576 6.88533L58.2583 4.87963L56.5517 6.09181L14.8801 35.6906L10.8645 38.5429L15.7883 38.413L39.903 37.777C38.6329 41.0304 37.5579 44.3799 36.6988 47.8366L36.6986 47.8372C34.0565 58.4855 33.5489 69.8943 35.334 81.1929C37.1122 92.469 41.2414 103.615 47.533 113.736C53.8283 123.863 62.3635 132.908 72.4703 140.019L73.8126 140.963L74.6327 139.541L91.7131 109.932L92.5915 108.409L90.9494 107.781C83.8595 105.071 77.1131 100.912 71.2694 95.3869C65.4555 89.8556 60.6012 82.9652 57.2224 75.1654C53.8447 67.368 51.9765 58.6798 51.9408 49.7238L52.349 42.0025Z",
    stroke: "black",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.0786133,
    y: 0.679443,
    width: 102.291,
    height: 161.669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b157af7a.svg";
export { ForwardRef as ReactComponent };